import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/comics";
import { parseViewsString } from "@/utils/format";

export default function RankingSection() {
  const ranking = [...mangaList]
    .sort((a, b) => parseViewsString(b.views) - parseViewsString(a.views))
    .slice(0, 8);

  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-labelledby="ranking-title">
      <div className="container-site">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="chip-tag">
              <i className="ri-fire-fill text-xs" aria-hidden="true" />
              人气飙升
            </span>
            <h2 id="ranking-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              人气排行榜
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              近 30 天热度最高的作品，大家都在追。
            </p>
          </div>
          <Link to="/category/all" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer">
            完整榜单<i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
          {ranking.map((comic, index) => (
            <Link
              key={comic.slug}
              to={`/article/${comic.slug}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:p-4 cursor-pointer"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                }`}
              >
                {index + 1}
              </span>
              <img
                src={comic.cover}
                alt={`${comic.title} 封面`}
                className="h-16 w-12 shrink-0 rounded-md object-cover object-top md:h-20 md:w-14"
              />
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">
                  {comic.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-600">
                  {comic.latestChapter}
                </p>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {comic.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500" aria-hidden="true" />
                    {comic.rating.toFixed(1)}
                  </span>
                  <span
                    className={`rounded-full px-1.5 py-0.5 text-[10px] ${
                      comic.status === "已完结" ? "bg-accent-100 text-accent-800" : "bg-primary-100 text-primary-700"
                    }`}
                  >
                    {comic.status}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line hidden text-xl text-foreground-400 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500 sm:block" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}